import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chitfundmenu',
  templateUrl: './chitfundmenu.component.html',
  styleUrls: ['./chitfundmenu.component.css']
})
export class ChitfundmenuComponent implements OnInit {
  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Chit fund')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/chitfund/chitfundmenu/chitfundmenu.component.ts